<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section>
  <header class="slds-grid">
    <div class="slds-m-right_large">
      <acc-help-button message="Show the hours spend for the selected week on the different projects and activity types."
                       title="Track 4D Dashboard">
        <ul class="slds-list_dotted">
          <li>Change the Week by clicking on the arrows or by entering the date</li>
        </ul>
        <p class="help-p">The Hours per Project/Activity can be displayed stacked or layered.</p>
        <p class="help-p">Click on the chart segments for details.</p>
      </acc-help-button>
    </div>

    <t4d-week-select></t4d-week-select>

    <div class="slds-m-left_large">
      <button (click)="onRefresh()"
              class="slds-button slds-button_icon slds-button_icon-border"
              i18n-title id="dash-refresh" title="Refresh">
        <svg aria-hidden="true" class="slds-button__icon">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
        </svg>
        <span class="slds-assistive-text">Refresh</span>
      </button>
    </div>
    <small style="margin: auto 0 auto 0.5rem; line-height: 0.9rem">{{message}}</small>
  </header>

  <div class="slds-scrollable_x">
    <t4d-bar-chart-stacked [cd]="projectData"></t4d-bar-chart-stacked>
    <t4d-bar-chart-stacked [cd]="activityData"></t4d-bar-chart-stacked>

    <t4d-pie-chart [cd]="expenseData"></t4d-pie-chart>
  </div>
</section>
